import { Turbo } from '@hotwired/turbo-rails'

Turbo.StreamActions.reload_frame = function () {
  const frame = document.getElementById(this.getAttribute('target'))
  if (!frame) return

  if (frame.src) {
    frame.reload()
  } else if (frame.dataset.defaultSrc) {
    frame.src = frame.dataset.defaultSrc
  }
}
